import { useState } from "react";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Instagram, Facebook, Youtube, Send } from "lucide-react";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're in. Watch for gentle notes.");
      setEmail("");
    } catch {
      toast.error("Something didn't land. Try again?");
    } finally {
      setBusy(false);
    }
  };

  return (
    <footer className="bg-ub-alt border-t border-ub mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <h3 className="font-serif text-4xl leading-tight">
            Notes from the <span className="font-script text-primary-ub">journey</span>
          </h3>
          <p className="mt-3 text-ub-2 max-w-md">
            Slow, honest, occasional letters from Anant — practices, reflections and program invitations.
          </p>
          <form onSubmit={subscribe} className="mt-6 flex items-center gap-2 max-w-md" data-testid="newsletter-form">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              data-testid="newsletter-email-input"
              className="flex-1 px-5 py-3 rounded-full bg-ub border border-ub focus:border-[var(--ub-primary)] outline-none transition-colors"
            />
            <button
              type="submit"
              disabled={busy}
              data-testid="newsletter-submit-btn"
              className="p-3 rounded-full bg-primary-ub text-white hover:bg-[var(--ub-primary-hover)] transition-colors"
            >
              <Send size={18} />
            </button>
          </form>
        </div>
        <div className="md:col-span-3">
          <div className="text-sm uppercase tracking-widest text-muted-ub">Explore</div>
          <ul className="mt-4 space-y-2">
            <li><Link to="/programs" className="hover:text-primary-ub">Programs</Link></li>
            <li><Link to="/quiz" className="hover:text-primary-ub">Find Your Program</Link></li>
            <li><Link to="/booking" className="hover:text-primary-ub">1:1 Coaching</Link></li>
            <li><Link to="/blog" className="hover:text-primary-ub">Wisdom Blog</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="text-sm uppercase tracking-widest text-muted-ub">Get in touch</div>
          <p className="mt-4 text-ub-2">Anant Pandit · Transformation Catalyst</p>
          <p className="text-ub-2">hello@universalbeing.life</p>
          <div className="flex gap-4 mt-5">
            <a href="#" aria-label="Instagram" className="p-2 rounded-full border border-ub hover:border-[var(--ub-primary)] hover:text-primary-ub transition-colors"><Instagram size={18} /></a>
            <a href="#" aria-label="Facebook" className="p-2 rounded-full border border-ub hover:border-[var(--ub-primary)] hover:text-primary-ub transition-colors"><Facebook size={18} /></a>
            <a href="#" aria-label="Youtube" className="p-2 rounded-full border border-ub hover:border-[var(--ub-primary)] hover:text-primary-ub transition-colors"><Youtube size={18} /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-ub">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-muted-ub">
          <p>© {new Date().getFullYear()} Universalbeing · Anant Pandit</p>
          <p className="font-script text-lg text-ub-2">Heal. Lead. Bloom.</p>
        </div>
      </div>
    </footer>
  );
}
